// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import request from '@/utils/request'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import './styles/global.css'
import 'lib-flexible/flexible.js'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import { setRemUnit, handleResize } from '@/utils/flexible';


// 初始化调用
setRemUnit();
window.addEventListener('resize', handleResize);

Vue.config.productionTip = false

Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI); // 全局注册所有组件
// ElementUI.locale(ElementUI.i18n.languages.en); // 英文语言包

// 挂载到Vue原型，组件内通过this.$axios调用
// Vue.prototype.$axios = request;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js